// Settings Context - src/context/Settings
import React, { useState } from "react";

export const QuickSearchValueContext = React.createContext();

const defaultValue = null;

export const QuickSearchContext = ({ children, value }) => {
  const [QuickSearchValue, setQuickSearchValue] = useState(defaultValue);

  const setValue = (values) => {
    setQuickSearchValue(values);
  };

  return (
    <QuickSearchValueContext.Provider
      value={{ value: QuickSearchValue, setValue }}
    >
      {children}
    </QuickSearchValueContext.Provider>
  );
};

export default QuickSearchContext;
